// extracted by mini-css-extract-plugin
module.exports = {"root":"MessageBoxContent-root-34397bba568942da519b7d1008274462 htmlContent-root-fe3506b39eaecd1a685ceda5e1292c4d"};